export default __webpack_public_path__ + "static/media/javascript.4028a6c8.png";